import React, { useState, useEffect } from 'react';
import chessslogo from '../../images/chessslogo.png';
import mansalva from '../../images/Mansalva/Mansalva-Regular.ttf';
import appStoreImage from '../../images/AppleStore.png';
import googlePlayImage from '../../images/GoogleStore.png';
import mockup1 from '../../images/Landing/Mockup_1.png';
import mockup2 from '../../images/Landing/Mockup_2.png';
import mockup3 from '../../images/Landing/Mockup_3.png';

const MobileBrowserLanding = () => {
  // Debug logging

  
  // Placeholder URLs - replace with actual store links
  const APP_STORE_URL = "https://apps.apple.com/app/id6751127037";
  const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.chessthread.app";

  // Rotating words state
  const rotatingWords = ['Creators', 'Players', 'Improvers', 'Coaches', 'Learners', 'Beginners', 'Masters'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [googlePlayClicked, setGooglePlayClicked] = useState(false);
  
  // Mockup switching state
  const mockups = [mockup1, mockup2, mockup3];
  const [currentMockupIndex, setCurrentMockupIndex] = useState(0);

  useEffect(() => {
    const wordInterval = setInterval(() => {
      setCurrentWordIndex((prevIndex) => (prevIndex + 1) % rotatingWords.length);
    }, 2000); // Change word every 2 seconds

    const mockupInterval = setInterval(() => {
      setCurrentMockupIndex((prevIndex) => (prevIndex + 1) % mockups.length);
    }, 3000); // Change mockup every 4 seconds

    return () => {
      clearInterval(wordInterval);
      clearInterval(mockupInterval);
    };
  }, [rotatingWords.length, mockups.length]);

  return (
    <div style={{
      minHeight: '100vh',
      background: "linear-gradient(to top, #3066BE, black)",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      color: '#ffffff',
      width: '100vw',
      padding: '20px',
      paddingTop: '40px',
      boxSizing: 'border-box',
      overflow: 'auto', 
      gap:''
    }}>
      {/* Font style declaration and animations */}
      <style>
        {`
          @font-face {
            font-family: 'Mansalva';
            src: url(${mansalva}) format('truetype');
            font-weight: normal;
            font-style: normal;
          }
          
          @keyframes slideUp {
            0% {
              transform: translateY(100%);
              opacity: 0;
            }
            20%, 80% {
              transform: translateY(0);
              opacity: 1;
            }
            100% {
              transform: translateY(-100%);
              opacity: 0;
            }
          }
          
          .rotating-word {
            animation: slideUp 2s ease-in-out infinite;
          }
        `}
      </style>
      
      {/* Logo */}
      <img 
        src={chessslogo} 
        alt="ChessThread" 
        style={{
          width: '75px',
          height: '75px',
          marginBottom: '20px'
        }}
      />
      
      {/* App Name */}
      <h1 style={{
        fontSize: '32px',
        fontFamily: 'Mansalva, cursive',
        fontWeight: 'normal',
        color: 'gold',
        margin: '0 0 0 0',
        letterSpacing: '2px',
        textAlign: 'center'
      }}>
        ChessThread
      </h1>

    

    

      {/* App Screenshot */}
      <div style={{
        width: '300px',
        marginBottom: '',
        marginTop: ''
      }}>
        <img
          src={mockups[currentMockupIndex]}
          alt="ChessThread App Screenshot"
          style={{
            width: '100%',
            height: 'auto',
            transition: 'opacity 0.5s ease-in-out'
          }}
        />
       
        
      </div>

        {/* App Store Download Buttons */}
        <div style={{
        width: '100%',
        maxWidth: '280px',
        display: 'flex',
        flexDirection: 'column',
        gap: '',
        marginTop: '',
        marginBottom: ''
      }}>
        {/* App Store Button */}
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'block',
            width: '100%',
            textDecoration: 'none'
          }}
        >
          <img 
            src={appStoreImage} 
            alt="Download on the App Store"
            style={{
              width: '100%',
              height: '80px',
              objectFit: 'cover',
              objectPosition: 'center',
              borderRadius: '8px'
            }}
          />
        </a>

          {/* Google Play Button */}
          {!googlePlayClicked ? (
          <div
            onClick={() => setGooglePlayClicked(true)}
            style={{
              display: 'block',
              width: '100%',
              cursor: 'pointer',
            }}
          >
            <img 
              src={googlePlayImage} 
              alt="Get it on Google Play"
              style={{
                width: '100%',
                height: '70px',
                objectFit: 'cover',
                objectPosition: 'center',
                borderRadius: '8px',
                
              }}
            />
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '70px',
              backgroundColor: '#000000',
              color: 'white',
              fontSize: '16px',
              fontWeight: 'bold',
              borderRadius: '8px',
              border: '1px solid #333'
            }}
          >
            Coming Soon to Google Play
          </div>
        )}
        
       
      </div>
      

      

      {/* For Chess [Rotating Word] Text */}
        {/* Tagline */}
        <p style={{
        fontSize: '20px',
        color: '#ffffff',
        margin: '0 0 10px 0',
        textAlign: 'center',
        fontWeight: 'bold',
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        letterSpacing: '0.5px',
        lineHeight: '1.3',
        marginTop: '20px',
        fontStyle: 'italic'
      }}>
        Create Chess Content
      </p>
      <div style={{
        fontSize: '16px',
        color: '#ffffff',
        margin: '0',
        fontWeight: 'bold',
        fontFamily: 'Arial, sans-serif',
        letterSpacing: '1px',
        height: '24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        fontStyle: 'italic',
        maxWidth: '280px',
        paddingBottom: '90px'
      }}>
        
          For Chess <span 
            key={currentWordIndex}
            className="rotating-word"
            style={{ marginLeft: '4px' }}
          >
            {rotatingWords[currentWordIndex]}
          </span>
        
      </div>
    </div>
  );
};

export default MobileBrowserLanding;